<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger()!"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="menuPositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayViewportMargin]="8"
  (attach)="handleOverlayAttach()"
  (overlayKeydown)="handleOverlayKeydown($event)"
  (overlayOutsideClick)="close()">
  <div
    cdkMenu
    cdkTrapFocus
    class="cui-dropdown__panel"
    tabindex="-1"
    (keydown)="handleMenuKeydown($event)">
    <ng-content />
  </div>
</ng-template>
